import addresses from 'config/constants/contracts'

const chainId = process.env.REACT_APP_CHAIN_ID
console.log(chainId,"chainId")

export const getCakeAddress = () => {
  // console.log(addresses.cake["97"],"cake address");
  return addresses.cake[chainId]
}
export const getMasterChefAddress = () => {
  return addresses.masterChef[chainId]
}
export const getMulticallAddress = () => {
  return addresses.mulltiCall[chainId]
}
export const getWbnbAddress = () => {
  return addresses.wbnb[chainId]
}
export const getLotteryAddress = () => {
  return addresses.lottery[chainId]
}
export const getLotteryTicketAddress = () => {
  return addresses.lotteryNFT[chainId]
}
